/**
 * Default Icon
 *
 * Generic pin icon used as fallback when no specific icon is available
 */

import { getStateColors } from './icon_helpers';

/**
 * Creates a default icon with state-based ring color
 * @param {string|null} state - Asset state (available, empty, low, etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createDefaultIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- State ring -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- Default icon - simple dot -->
      <circle cx="123.75" cy="123.75" r="15" fill="${colors.iconColor}"/>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

// Marker to identify default icon
export const DEFAULT_ICON_MARKER = 'DEFAULT_ICON';
